module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style8/cards-style8.component.scss
// module id = ./src/app/features/cards/cards-style8/cards-style8.component.scss
// module chunks = main